import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import axios from "axios";
import * as yup from "yup";
import { toast } from "react-toastify";
import Step1 from "./Steps/Step1";
import { useHistory, useLocation } from "react-router-dom";
import { values } from "lodash";

const INITIAL_VALUES = {
  name: "",
  plan_type: "",
  limits: [],
  is_universal: false
};

export default function AddPlanGroups(props) {
  const history = useHistory();
  const location = useLocation();
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);
  const [featureGroupId, setFeatureGroupId] = useState(
    props.match.params.plan_group_id
  );
  const [loading, setLoading] = useState(true);

  useEffect(
    () => {
      const fetchInitialValues = async () => {
        if (featureGroupId) {
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL}/feature_groups/${featureGroupId}`
            );
            const data = response.data.data;
            if (location.pathname.includes("/copy")) {
              data.name = "";
            }

            setInitialValues({
              name: data.name || "",
              plan_type: data.plan_type || "",
              limits: data.limits || [],
              is_universal: data.is_universal === 1 ? true : false
            });
          } catch (error) {
            console.error("Erro ao buscar os dados do grupo de planos", error);
            toast.error("Erro ao carregar dados iniciais.");
          }
        }
        setLoading(false);
      };

      fetchInitialValues();
    },
    [featureGroupId],
    location.pathname
  );

  async function onCreate(values) {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feature_groups`,
      {
        name: values.name,
        limits: values.limits,
        plan_type: values.plan_type,
        is_universal: values.is_universal
      }
    );
    return response.data;
  }

  async function onEdit(values) {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/feature_groups/${featureGroupId}`,
      {
        name: values.name,
        limits: values.limits,
        plan_type: values.plan_type,
        is_universal: values.is_universal
      }
    );
    return response.data;
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      const isCreating = location.pathname.includes("/copy") || !featureGroupId;
      try {
        const result = isCreating
          ? await onCreate(values)
          : await onEdit(values);
        toast.success("Grupo de planos salvo com sucesso!");
        history.push("/plan_groups");
      } catch (error) {
        toast.error(
          "Ops... tivemos um problema de conexão por isso não conseguimos salvar seu grupo de planos."
        );
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("O campo nome é obrigatório!"),
      plan_type: yup.string().required("O campo tipo é obrigatório!")
    })
  });
  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <Step1 step={0} setStep={() => {}} formik={formik} id={featureGroupId} />
  );
}
